import { render } from "./view-delivery-challan.vue?vue&type=template&id=ad205d10&scoped=true"
import script from "./view-delivery-challan.vue?vue&type=script&lang=js"
export * from "./view-delivery-challan.vue?vue&type=script&lang=js"

import "./view-delivery-challan.vue?vue&type=style&index=0&id=ad205d10&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad205d10"]])

export default __exports__